import { render } from "./MainOurOffersComponent.vue?vue&type=template&id=c6b5a4ba"
const script = {}

import "./MainOurOffersComponent.vue?vue&type=style&index=0&id=c6b5a4ba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__